<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content align-center">
			<frequently-asked-questions v-for="faq in faqs" :key="faq.ID" :items="faq.faqitems" :header="faq.header" />
		</section>

		<contentblocks :items="page.contentblocks" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: faqs } = await useWebsiteFetch('frequentlyAskedQuestions', {
	query: { language: locale.value },
	key: `${locale.value}/frequentlyAskedQuestions`,
});
</script>
